require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-holiday-gift-guide-best-business-books.json") })
        }
      }, "path---tapd-in-holiday-gift-guide-best-business-books");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-holiday-gift-guide-best-business-books!./.cache/json/tapd-in-holiday-gift-guide-best-business-books.json
// module id = 836
// module chunks = 231608221292675